import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router'
import urlDecode from '../../../../helpers/urlDecode'
import { useVehicleContext } from '../../../../contexts/vehicle.context'

const urlSequence = [
  'year', 'make', 'model', 'submodel', 'engine',
]

const useVLPHomeRedirect = () => {
  const history = useHistory()
  const vehicleState = useVehicleContext()
  const vehicleDB = useMemo(() => vehicleState.vehicleDB || [], [vehicleState.vehicleDB])
  const selectedVehicle = useMemo(
    () => vehicleDB.find(element => element.selected) || {},
    [vehicleDB],
  )
  return useCallback(
    () => {
      let urlQuery = '/'

      if (selectedVehicle.year) {
        urlQuery = urlSequence.reduce(
          (query, param) => {
            const { [param]: paramValue } = selectedVehicle
            const vehicleParams = paramValue ? `/${urlDecode(paramValue)}` : ''
            return `${query}${vehicleParams}`
          },
          '/vehicle',
        )
      }

      history.push(urlQuery)
    },
    [history, selectedVehicle],
  )
}

export default useVLPHomeRedirect
